import React from 'react';

// @mui/material components
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import makeStyles from '@mui/styles/makeStyles';

const makeLocalStyles = makeStyles((theme) => ({
  inactiveFilterIcon: {
    cursor: 'pointer !important',
    fontSize: '13px',
    color: '#adaaac',
    marginLeft: '-12px',
    '&:hover': {
      backgroundColor: '#E7E7E7',
      color: '#000000',
    },
  },
  activeFilterIcon: {
    cursor: 'pointer !important',
    fontSize: '13px',
    color: '#000000',
    marginLeft: '-12px',
    '&:hover': {
      backgroundColor: '#E7E7E7',
      color: '#000000',
    },
  },
}));

const ColumnFilterIcon = ({ onClick, shouldHighlight }) => {
  const myStyles = makeLocalStyles();

  return (
    <Tooltip title="Filter">
      <IconButton
        aria-label="filter"
        onClick={onClick}
        className={shouldHighlight() ? myStyles.activeFilterIcon : myStyles.inactiveFilterIcon}
        size="large"
      >
        <i className="fa fa-filter" />
      </IconButton>
    </Tooltip>
  );
};

export default ColumnFilterIcon;
